import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';

const Snipcart = () => {
  return (
    <>
      <h5>
        <b>Snipcart</b>
      </h5>
      <p>
        Snipcart is a commerce platform that allows anyone to integrate a shopping cart to their app
        or website within few minutes.
      </p>
      <br />
      <DocsLink link="https://academy.drapcode.com/docs/app-plugin/snipcart-plugin/" />
    </>
  );
};

export default Snipcart;
